import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Container, Typography, Link } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  headTextStyle: {
    textTransform: "uppercase",
    marginBottom: "1.5em",
    textAlign: "left",
  },
  linkStyle: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    textAlign: "left",
    display: "block",
    marginBottom: "1rem",
    fontSize: "1rem",
    fontWeight: "light",
  },
}));

const FooterCenter = () => {
  const classes = useStyle();
  return (
    <Container>
      <Typography className={classes.headTextStyle} color="secondary">
        Navigation
      </Typography>
      <Link href="/about" className={classes.linkStyle}>
        About Us
      </Link>
      <Link href="/services/individuals" className={classes.linkStyle}>
        Services
      </Link>
      <Link href="/shop" className={classes.linkStyle}>
        Shop
      </Link>
      <Link href="/contact" className={classes.linkStyle}>
        Contact
      </Link>
    </Container>
  );
};

export default FooterCenter;
